module.exports = __webpack_public_path__ + "static/media/apple-macbook-pro.d2603190.svg";